<div class="bonds-panel">
    <div class="btns-filters justify-content-between">
        <div class="buscador-event container-form d-flex align-items-center borderInput">
            <i class="fal fa-search search-icon pointer-in" (click)="searchEvents(searchInput.value)"></i>
            <input #searchInput class="input-custom w-100" type="text" placeholder="Buscar abono"
                [ngModel]="searchText" (input)="searchEvents(searchInput.value)">
        </div>
        <div class="btns-create" *ngIf="allowCreate">
            <div class="btn-create btn-create-border btn-bono m-0" [routerLink]="['/panel-control/bonds/create']">
                <i class="fal fa-plus-circle"></i>
                <p class="m-0">Crear abono</p>
            </div>
        </div>
    </div>

    <div *ngIf="loadingPage" class="container-lottie">
        <div class="loading-container">
            <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
                containerClass="loading-box"></ng-lottie>
        </div>
    </div>

    <div #containerScroll class="table-events table-panel multiple-lines" *ngIf="loaded"
        (scroll)="isScrolledInfinityView($event)">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z28" matSort (matSortChange)="sortData($event)">
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let bond">
                    <div [matMenuTriggerFor]="actionOptions" style="width: 20px;" class="pointer-in d-flex justify-content-center">
                        <i class="icon-option fal fa-ellipsis-vertical"></i>
                    </div>
                    <mat-menu class="options-menu-control-panel" #actionOptions="matMenu">
                        <button mat-menu-item [routerLink]="['/panel-control/bonds/edit', bond.id]" *ngIf="allowCreate"><i class="fal fa-pen-to-square" style="margin-right: 8px;"></i>Editar</button>
                        <button mat-menu-item (click)="toggleBondStatus(bond)" *ngIf="allowCreate">
                            <i class="fal" [ngClass]="bond.active ? 'fa-toggle-off' : 'fa-toggle-on'" style="margin-right: 8px;"></i>
                            {{bond.active ? 'Desactivar' : 'Activar'}}
                        </button>
                        <button mat-menu-item (click)="deleteBond(bond)" *ngIf="!(bond.purchases > 0) && allowCreate" class="delete-action"><i class="fal fa-trash-can" style="margin-right: 8px;"></i>Eliminar</button>
                    </mat-menu>
                </td>
            </ng-container>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-ticket th-icon"></i> Abono</b></th>
                <td mat-cell *matCellDef="let bond" [routerLink]="['/panel-control/bonds/edit', bond.id]">
                    <span class="link-titulo">{{bond.name}}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="discount">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-percent th-icon"></i> Descuento</b></th>
                <td mat-cell *matCellDef="let bond" [routerLink]="['/panel-control/bonds/edit', bond.id]">
                    <span class="value-display" *ngIf="bond.fixed_price">
                        Precio fijo<ng-container *ngIf="bond.price_summary?.from != null"> · desde {{ bond.price_summary.from | number:'1.2-2':'es' }} €</ng-container>
                    </span>
                    <span class="value-display" *ngIf="!bond.fixed_price">{{bond.discount_mode == "percentage" ? bond.discount_value + '%' : bond.discount_value + '€'}}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-signal-bars th-icon"></i> Estado</b></th>
                <td mat-cell *matCellDef="let bond" [routerLink]="['/panel-control/bonds/edit', bond.id]">
                    <span class="status-badge" [ngClass]="{
                        'status-badge--active': getStatus(bond).color === '#21CB7C',
                        'status-badge--inactive': getStatus(bond).color === '#FFA800',
                        'status-badge--ended': getStatus(bond).color === '#B75470',
                        'status-badge--draft': getStatus(bond).color === '#7A7A7A'
                    }">
                        <i class="fa-solid" [ngClass]="{
                            'fa-circle-check': getStatus(bond).color === '#21CB7C',
                            'fa-circle-pause': getStatus(bond).color === '#FFA800',
                            'fa-circle-xmark': getStatus(bond).color === '#B75470',
                            'fa-circle-exclamation': getStatus(bond).color === '#7A7A7A'
                        }"></i>
                        {{getStatus(bond).status}}
                    </span>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div class="pagination-component">
            <div class="d-flex align-items-center pagination-panel pagination-table"
                *ngIf="!loadingPage && !finishScroll">
                <div>
                    <ng-lottie class="lottie-pagination" [options]="{path: 'assets/lotties/loading.json'}"
                        containerClass="loading-box"></ng-lottie>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="loaded && !loadingPage && eventos?.length <= 0" class="empty-state">
        <i class="fal fa-ticket"></i>
        <p>No hay abonos disponibles</p>
        <span>Crea tu primer abono para empezar</span>
    </div>
</div>